import { Navbar, Nav, Container } from "react-bootstrap";

const NavbarAtas = () => {
  return (
    <Navbar collapseOnSelect expand="lg" variant="dark">
      <Container>
        <Navbar.Brand href="/">freeSpace</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="menuBar ms-auto">
            <Nav.Link href="/projects">portofolio.</Nav.Link>
            {/* <Nav.Link href="/contact">contact.</Nav.Link> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarAtas;
